// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3fjeL","choiceBoxes":"toolbarselects_choiceBoxes__39Y5Z","simpleField":"toolbarselects_simpleField__1HfE6"};